import {
  type NutrientsTargets,
  type TraineeNutritionGeneratorFormModel,
} from "@fitness-app/utils/src/nutrition/mealsPlanGenerators";
import { useQueryClient } from "@tanstack/react-query";

import { useBackgroundTasks } from "~/modules/Dashboard/BackgroundTasksDrawer/BackgroundTasksProvider";
import { useBackgroundTasksQuery } from "~/modules/Dashboard/BackgroundTasksDrawer/useBackgroundTasks";
import { useTraineeSearchParams } from "~/modules/Trainee/TraineeProfile/scope";

export const useGenerateNutrition = (traineeId: string, onSuccessCallback?: () => void) => {
  const { openDrawer } = useBackgroundTasks();
  const { createNutritionPlanTask, isCreatingNutritionPlanTask } = useBackgroundTasksQuery({ enabled: false });
  const queryClient = useQueryClient();
  const [_searchParams, setSearchParams] = useTraineeSearchParams();

  const generateNutrition = async (formData: TraineeNutritionGeneratorFormModel, targets: NutrientsTargets) => {
    const response = await createNutritionPlanTask({
      ...formData,
      targets,
      traineeId,
    });
    onSuccessCallback?.();
    if (response.emptyTemplate && response.planId) {
      await queryClient.invalidateQueries(["draftNutritionPlans", traineeId]);
      setSearchParams({ template: "true", planId: response.planId, tab: "nutrition", nutritionTab: "schedule" });
      return;
    }
    openDrawer();
  };

  return {
    generating: isCreatingNutritionPlanTask,
    generateNutrition,
  };
};
